import { useMutation } from "react-query";

import { EpdBlockIProps } from "~/components/Forms/DealerPassportForm2/requests/getEpd";
import { updateEpd } from "~/components/Forms/DealerPassportForm2/requests/updateEpd";

export default function useUpdateEpd() {
  return useMutation({
    mutationFn: ({
      dealerId,
      data,
    }: {
      dealerId: string;
      data: EpdBlockIProps[];
    }) => updateEpd(dealerId, data),
  });
}
